import { merge } from "lodash/fp";
import { HubThemePartial } from "../../types";
import hkmaThemeBase from "./_base";

const hkmaPreviewTheme: HubThemePartial = merge(hkmaThemeBase, {
  meta: {
    config: {
      featureSet: {
        tracking: {
          plausible: {
            enabled: true,
            allowLocalTracking: false,
            siteDomain: "preview.climaterisk.hk",
          },
        },
      },
      portfolioExport: {
        assetLevelDeepDive: {
          outputTypes: ["small", "screen", "exposures"],
        },
      },
    },
  },
} as HubThemePartial);

export default hkmaPreviewTheme;
